export default {
  referee: (param) => `profile/referees?${buildQuery(param)}`,
  editreferee: "profile/referees/update",
  postreferee: "profile/referees",
  deletereferee: (param) => `profile/referees/destroy?${buildQuery(param)}`,
};

function buildQuery(param) {
  const query = new URLSearchParams(param);
  return query.toString();
}
